export default function ItalianFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="20"
      viewBox="0 0 28 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6855_507)">
        <rect x="0.865234" y="0.617188" width="26.2691" height="18.7636" rx="3.75273" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3779 0.617188H27.1343V19.3808H18.3779V0.617188Z"
          fill="#F93939"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.865234 0.617188H9.6216V19.3808H0.865234V0.617188Z"
          fill="#249F58"
        />
      </g>
      <defs>
        <clipPath id="clip0_6855_507">
          <rect x="0.865234" y="0.617188" width="26.2691" height="18.7636" rx="3.75273" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
